export interface CategoryGroup {
  id: number;
  publicId: string;
  name: string;
}

export interface APICategoryGroup {
  id: number;
  public_id: string;
  name: string;
}

export interface PostCategoryGroup {
  name: string;
  type: CategoryType;
}

export interface PutCategoryGroup {
  id: number;
  name: string;
  type: CategoryType;
}

export interface APICategory {
  id: number;
  name: string;
  color: string;
  is_deleted: boolean;
  deleted_at: string;
  type: CategoryType;
  group?: CategoryGroup;
}

export enum CategoryType {
  EXPENSE = "expense",
  INCOME = "income",
}

export enum CategoryGroupType {
  EXPENSE = "expense",
  INCOME = "income",
}

export interface Category {
  id: number;
  name: string;
  color: string;
  isDeleted: boolean;
  deletedAt: string;
  type: CategoryType;
  group?: CategoryGroup;
}

export interface PutCategory {
  id: number;
  name: string;
  type: CategoryType;
  groupId?: number;
}
